import axios from 'axios';
import { getAccessToken, getRefreshToken } from '../../Utils/storageUtils';

// Function to refresh the token (this should return a Promise with the new token)
const refreshAuthToken = async () => {
  try {
    const response = await pfmClientAxiosInstance.post('/auth/refreshToken', {
      refreshToken: getRefreshToken(),
    });
    const { accessToken } = response.data;
    return accessToken;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    throw error;
  }
};

const pfmClientAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PFM_CLIENT_BASEURL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`,
  },
});

export const pfmAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PFM_BASEURL,
  headers: {
    'Content-Type': 'application/json',
    API_KEY: `51bb7d2654ec3ec20a74f16ab0`,
  },
});

pfmClientAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.config.url.includes('/pfm-sdk')
    ) {
      try {
        const newAccessToken = await refreshAuthToken();
        error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return pfmClientAxiosInstance(error.config);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default pfmClientAxiosInstance;
